import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalDismissReasons, AslibModalService } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';
import { AslibLoadingService } from '@aslib/loading';
import { Messages } from '../../shared/helpers/mensages';
import { InputDadosModelView, OutputDadosModelView } from './shared/model/transmissao-arquivo-ipm.model';
import {TransmissaoArquivoIpmService} from './shared/service/transmissao-arquivo-ipm.service';
import { debug } from 'console';

@Component({
  selector:'sarf-transmissao-arquivo-ipm',
  templateUrl:'./transmissao-arquivo-ipm.component.html'
})

export class TransmitirArquivoIpmComponent implements OnInit {
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;
  outputDadosModelView: OutputDadosModelView;
  inputDadosModelView: InputDadosModelView;
  nomeArquivo: string = "";
  credenciais: any;
  @ViewChild('fileInput') fileInput : any;
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;

  formTransmitirPlanilha = new FormGroup({
    TipoReceita: new FormControl(undefined, Validators.required),
    ArquivoIpm: new FormControl(undefined, Validators.required)
  })

  constructor(
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    private readonly _aslibModalService: AslibModalService,
    private readonly _messages : Messages,
    private readonly _transmissaoArquivoIpmService : TransmissaoArquivoIpmService
  ) {
    modalManagerHelper.parent = this;
    this.outputDadosModelView = new OutputDadosModelView();
    this.inputDadosModelView = new InputDadosModelView();
  }

  ngOnInit() {

    this.credenciais = { user: '', password: ''};
    this.dadosOnInitFormulario(this.modalMensagem);

  }

  dadosOnInitFormulario(modal: AslibModalComponent){
this._aslibLoadingService.start();
  this.subscription =  this._transmissaoArquivoIpmService.DadosOnInitFormulario()
      .subscribe( result => {
        this.outputDadosModelView = result;
      },
      () => {
       this.unSubscribe();
      });
  }
  

  TransmitirArquivoIpm(modal: AslibModalComponent) {
    this._aslibLoadingService.start();
    const formData = new FormData();
    formData.append('upload', this.fileInput.nativeElement.files[0]);
    formData.append('idTipo', this.inputDadosModelView.TipoReceitaSelected.IdTipoReceita);
    formData.append('user', this.credenciais.user);
    formData.append('password', this.credenciais.password);

  this.subscription =  this._transmissaoArquivoIpmService.ValidaTransmitirArquivoIpm(formData).subscribe(
      retornoRequest =>{
        if(retornoRequest.Status){
                if(retornoRequest.CodigoSituacao == 2){
                  this.modalManagerHelper.modalpergunta(modal,null, retornoRequest.objetoMensagem, 'Transmitir', 'Cancelar');
                  modal.open().result.then(
                    result => {
                            if (AslibModalDismissReasons[result] === 'OK') {
                              this.TransmicaoAceito(modal, formData);  
                            }
                          },
                          reason => { }
                  );
                  this.unSubscribe();
                  return;
                }else{
                    this.TransmicaoAceito(modal, formData);  
                }
        }else{
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
          this.unSubscribe();
          return;
        }

      },
      () => {
       this.unSubscribe();
      }
     );
  }

  TransmicaoAceito(modal: AslibModalComponent, formData: FormData){
      this.subscription =  this._transmissaoArquivoIpmService.TransmitirArquivoIpm(formData).subscribe(
        retornoRequest =>{
          if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
            this.fileInput.nativeElement.value = "";  
            this.inputDadosModelView.TipoReceitaSelected = undefined;
            this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
            this.unSubscribe();
          }
        },
        () => {
          this.unSubscribe();
        }
      );
  }

  openModalCredenciaisFTP(modalCredenciais: AslibModalComponent, modalMensagem: AslibModalComponent, content) {

    // Parametros do modal
    const options: {} = {
      title: 'Credenciais de Acesso',
      backdrop: 'static',
      okText: 'Conectar',
      cancelarVisible: true,
      size: 'sm',
      content: content
    };

    // Carrega um modal para exibição de mensagem
    modalCredenciais.open(options).result.then(
      () => {

        if (this.credenciais.user != null && this.credenciais.user != undefined && this.credenciais.user != '') {
          if (this.credenciais.password != null && this.credenciais.password != undefined && this.credenciais.password != '') {
            this.TransmitirArquivoIpm(modalMensagem);
          }
        }

      },
      () => { }
    );

  }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/ipm/transmissao-arquivo-ipm/transmissao-arquivo-ipm.component.ts